import { createAction, props } from "@ngrx/store";

export const LOAD_SYSTEM_TIME = createAction("[SystemTime] Load System Time");

export const SET_SYSTEM_TIME = createAction(
  "[SystemTime] SetSystem Time",
  props<{ systemTime: Date }>()
);

export const LOAD_TIME_TRAVEL_IS_ACTIVE = createAction(
  "[SystemTime] Load Time Travel Active"
);

export const LOAD_TIME_TRAVEL_AUTHORIZED = createAction(
  "[SystemTime] Load Time Travel Authorized"
);

export const SET_TIME_TRAVEL_IS_ACTIVE = createAction(
  "[SystemTime] Set Time Travel Active",
  props<{ isTimeTravelOn: boolean }>()
);

export const SET_TIME_TRAVEL_AUTHORIZED = createAction(
  "[SystemTime] Set Time Travel Authorized",
  props<{ authorized: boolean }>()
);

export const UPDATE_SYSTEM_TIME = createAction(
  "[SystemTime] Update System Time",
  props<{
    newSystemTime: Date;
  }>()
);
